import { render, staticRenderFns } from "./CreateDiyGoodOrderModal.vue?vue&type=template&id=1418a5ae&scoped=true&"
import script from "./CreateDiyGoodOrderModal.vue?vue&type=script&lang=js&"
export * from "./CreateDiyGoodOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateDiyGoodOrderModal.vue?vue&type=style&index=0&id=1418a5ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1418a5ae",
  null
  
)

export default component.exports